
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import type { TAbout, TBanner, TSlide } from "@type/home";
import { getHomePage } from "@utils/get-home-page";
import Carousel from "framer-motion-carousel";
import type { GetStaticProps, NextPage } from "next";
import Image from "next/image";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import { About } from "../components/about";
import { HeroProducts } from "../components/hero-products";
import { News } from "../components/news";
import { Partners } from "../components/partners";
import { Promotion } from "../components/promotion";
import type { TPost } from "../types/posts";
import { getAllPosts } from "../utils/get-posts";
interface IPost {
    about: TAbout;
    banners: TBanner[];
    posts: TPost[];
    slides: TSlide[];
}
const Index: NextPage<IPost> = ({ posts, slides, about, banners }) => {
    const { t } = useTranslation("common");
    // const obnizka = lang === 'it' ? 'obnizka55it' : 'obnizka55';
    // const slider =
    //   lang === 'pl'
    //     ? [
    //         'pergole-balustrady',
    //         'obnizka-KNS-8',
    //         'obnizkaHSInowa',
    //         // 'KNSwspieraMMA',
    //         'obnizka18',
    //         obnizka,
    //         'okno',
    //         'slide1',
    //         'slide2',
    //       ]
    //     : ['slide1', 'slide2'];
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl", hrefLang: "x-default" },
            { href: "https://knswindows.com", hrefLang: "en" },
            { href: "https://knsokna.pl", hrefLang: "pl" },
            { href: "https://knsfenster.de", hrefLang: "de" },
            { href: "https://kns-okna.eu", hrefLang: "cs" },
            { href: "https://knsfinestre.it", hrefLang: "it" },
            { href: "https://knsfenetres.fr", hrefLang: "fr" },
            { href: "https://knsokna.eu", hrefLang: "hu" },
        ]}/>
      <div className="relative inset-0 sm:-mt-4">
        <div className="-mt-12 h-[calc(100svh)] w-screen sm:-mt-28">
          <Carousel autoPlay={true} interval={5000} loop={true}>
            {slides.map((item, i) => (<React.Fragment key={i}>
                {item.url ? (<Link href={item.url}>
                    <Image alt={"slide"} className="block h-full w-full object-cover md:hidden" height="800" key={`${i}m`} priority={true} quality={100} src={item?.mobileimg?.sourceUrl} style={i === 1 ? { objectPosition: "50%" } : {}} width="500"/>
                    <Image alt={"slide"} className="hidden h-full w-full object-cover md:block" height="1200" key={i} priority={true} src={item?.desktopimg?.sourceUrl} style={i === 1 ? { objectPosition: "50%" } : {}} width="1920"/>
                  </Link>) : (<>
                    <Image alt={"slide"} className="block h-full w-full object-cover md:hidden" height="800" key={`${i}m`} priority={true} quality={100} src={item?.mobileimg?.sourceUrl} style={i === 1 ? { objectPosition: "50%" } : {}} width="500"/>
                    <Image alt={"slide"} className="hidden h-full w-full object-cover md:block" height="1200" key={i} priority={true} src={item?.desktopimg?.sourceUrl} style={i === 1 ? { objectPosition: "50%" } : {}} width="1920"/>{" "}
                  </>)}
              </React.Fragment>))}
          </Carousel>
        </div>
        {/* <div className="hidden sm:flex h-wscreen z-10 absolute bottom-1/4">
          <div className="m-auto p-4 text-white">
            <div className="ml-0 md:ml-96 md:mt-24 p-3 bg-black bg-opacity-75">
              <h1 className="text-4xl">{t('home.title')}</h1>
              <span className="text-xl block">{t('home.subtitle')}</span>
            </div>
          </div>
        </div> */}
        <div className="absolute bottom-0 h-24 w-screen bg-white sm:h-28">
          <div className="mx-auto mt-1 max-w-7xl">
            <Partners />
          </div>
        </div>
      </div>
      <div className="m-auto px-4 py-8 text-center text-black">
        <div className="p-3">
          <h1 className="text-4xl">{t("home.title")}</h1>
          <h2 className="block text-xl">{t("home.subtitle")}</h2>
        </div>
      </div>
      <HeroProducts />
      <About {...about}/>
      <Promotion banners={banners}/>
      {/* <div className="bg-gray-50">
          <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 text-center">
            <Image
              src="/img/kns-w-liczbach.png"
              alt="mapa"
              width="1214"
              height="382"
            />
          </div>
        </div> */}
      <News posts={posts}/>
      <div className="bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:flex lg:items-center lg:justify-between lg:px-8 lg:py-16">
          <h2 className="font-extrabold text-3xl text-gray-900 tracking-tight sm:text-4xl">
            <span className="block">{t("home.findProducts1")}</span>
            <span className="block text-indigo-600">
              {t("home.findProducts2")}
            </span>
          </h2>
          <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
            <div className="ml-3 inline-flex rounded-md shadow">
              <a className="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 font-medium text-base text-indigo-600 hover:bg-indigo-50" href="/contact">
                {t("seeMore")}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50">
        <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:flex lg:items-center lg:justify-between lg:px-8 lg:py-16">
          <Image alt="mapa" height="1110" src="/img/swiat.jpg" width="1928"/>
          {/* <div className="mt-8 flex flex-col lg:mt-0 lg:flex-shrink-0">
          {languages.flatMap((item, index) => (
            <div
              className="ml-3 inline-flex rounded-md shadow my-2"
              key={index}
            >
              <a
                href="#"
                className="w-100 inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-indigo-50"
              >
                <img
                  src={`/img/locales/${item.locale}.svg`}
                  width="24"
                  height="24"
                  className="rounded-full drop-shadow-md mr-3"
                />
                {item.name}
              </a>
            </div>
          ))}

        </div> */}
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const language = locale === "cz" ? "CS" : locale.toUpperCase();
    const { allPosts } = await getAllPosts(language, 3);
    const posts = allPosts?.posts?.nodes ?? [];
    const { slides, about, banners } = await getHomePage(language);
    return {
        props: {
            about,
            banners,
            posts,
            slides,
        },
    };
};
export default Index;

    async function __Next_Translate__getStaticProps__1a19cd2bede__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bede__ as getStaticProps }
  